// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"9c717050","212":"f6340b21","220":"fe81ffe6","300":"a39a3669","320":"98e5f0ed","404":"2c02d09b","504":"62a5bf39","592":"a580fd38","792":"f83cabff","856":"dce983a9","924":"a95a3c50","939":"a4125828","952":"cbb41b17","992":"b8c047c8"}[chunkId] + ".chunk.js";
};